"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var axios_1 = __importDefault(require("axios"));
var constant_1 = require("../constant");
var newAxios = axios_1["default"].create();
var processErrorData = function processErrorData(data) {
  return data;
};
/**
 * 对返回结果进行json 解析
 * @param data
 * @returns
 */
var parseDataFun = function parseDataFun(data) {
  try {
    // 对接收的数据进行 parse
    var parseData = JSON.parse(data);
    if (Array.isArray(parseData === null || parseData === void 0 ? void 0 : parseData.config)) {
      // 对配置数组里的配置数据进行 parse
      var config = parseData === null || parseData === void 0 ? void 0 : parseData.config.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          config_data: JSON.parse(item.config_data)
        });
      });
      return _objectSpread(_objectSpread({}, parseData), {}, {
        config: config
      });
    }
    // @ts-ignore
    // window.consumer_config_info = parseData ?? undefined;
    if (parseData !== null && parseData !== void 0 && parseData.config) {
      var _parseData$config;
      return _objectSpread(_objectSpread({}, parseData), {}, {
        config: _objectSpread(_objectSpread({}, parseData.config), {}, {
          config_data: (_parseData$config = parseData.config) !== null && _parseData$config !== void 0 && _parseData$config.config_data ? JSON.parse(parseData.config.config_data) : undefined
        })
      });
    }
    return parseData;
  } catch (err) {
    console.log('parse data error========>', err);
    throw new Error(_objectSpread(_objectSpread({}, err), {}, {
      message: 'parse data error========>'
    }));
  }
};
var getUrlParams = function getUrlParams(url) {
  var params = {};
  new URL(url).searchParams.forEach(function (value, key) {
    params[key] = value;
  });
  return params;
};
/**
 * cdn 兜底获取数据
 * @param domain
 * @param app
 * @param config
 */
var getConfigByCdn = function getConfigByCdn(domain, app, config) {
  var _location;
  // 根据不同区域决定 cdn host
  var urlParams = getUrlParams((_location = location) === null || _location === void 0 ? void 0 : _location.href);
  var cdnUrl = constant_1.sgAndVacdnHostUrl.join('.');
  var centerUrl = 'oec-config-center-sg';
  if (urlParams['assign_cdn']) {
    if (urlParams['assign_cdn'] === 'is_boe') {
      cdnUrl = constant_1.boeCdnHostUrl.join('.');
      centerUrl = 'oec-config-center';
    }
    if (urlParams['assign_cdn'] === 'is_us') {
      cdnUrl = constant_1.usCdnHostUrl.join('.');
      centerUrl = 'oec-config-center-us';
    }
    if (urlParams['assign_cdn'] === 'is_eu') {
      cdnUrl = constant_1.euCdnHostUrl.join('.');
      centerUrl = 'oec-config-center-euttp';
    }
  } else {
    var _location2, _location3;
    if ((_location2 = location) !== null && _location2 !== void 0 && _location2.host.includes('-boe')) {
      cdnUrl = constant_1.boeCdnHostUrl.join('.');
      centerUrl = 'oec-config-center';
    }
    if ((_location3 = location) !== null && _location3 !== void 0 && _location3.host.includes('-us')) {
      cdnUrl = constant_1.usCdnHostUrl.join('.');
      centerUrl = 'oec-config-center-us';
    }
    var euUrl = ['-de', '-es', '-fr', '-ie', '-it'];
    var containsString = euUrl.some(function (str) {
      var _location4;
      return (_location4 = location) === null || _location4 === void 0 ? void 0 : _location4.host.includes(str);
    });
    if (containsString) {
      cdnUrl = constant_1.euCdnHostUrl.join('.');
      centerUrl = 'oec-config-center-euttp';
    }
  }
  var cdnHost = "https://".concat(cdnUrl, "/obj/").concat(centerUrl, "/prod");
  var cdnLink = "".concat(cdnHost, "/").concat(domain, "-").concat(app);
  if (config) {
    cdnLink = "".concat(cdnHost, "/").concat(domain, "-").concat(app, "-").concat(config);
  }
  // cdn 兜底逻辑
  return newAxios.get(cdnLink).then(function (response) {
    var processData = response.data;
    return {
      domain_name: domain,
      app_name: app,
      config_name: config,
      config_data: processData
    };
  })["catch"](function (cdnError) {
    console.error('CDN source also failed ====> ', cdnError);
    throw new Error(cdnError);
  });
};
var getConfigByCdnByConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(domain, app, config) {
    var promises, configCdn, config_data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!config) {
            _context.next = 14;
            break;
          }
          if (!Array.isArray(config)) {
            _context.next = 9;
            break;
          }
          promises = config.map(function (item) {
            return getConfigByCdn(domain, app, item);
          }); // Promise.all 接收一个 promise 数组作为参数，返回新的 promise
          // 只有当所有 promise 都成功时，这个新的 promise 才成功，返回值是一个数组，包含所有 promise 的返回值
          // 任何一个 promise 失败，返回的 promise 就失败
          _context.next = 5;
          return Promise.all(promises).then(function (responses) {
            return Promise.all(responses);
          }) // 调用 json() 也返回一个 promise，所以也用 Promise.all
          .then(function (data) {
            // 这里所有请求的结果都在 data 数组中
            return data;
          })["catch"](function (err) {
            // 如果请求有任何错误，你都可以在这里得知
            console.error(err);
            throw new Error('getConfigByCdnByConfig error');
          });
        case 5:
          configCdn = _context.sent;
          _context.next = 8;
          return Promise.resolve({
            code: 0,
            msg: 'success',
            config: configCdn
          });
        case 8:
          return _context.abrupt("return", _context.sent);
        case 9:
          if (!(typeof config === 'string')) {
            _context.next = 14;
            break;
          }
          _context.next = 12;
          return getConfigByCdn(domain, app, config);
        case 12:
          config_data = _context.sent;
          return _context.abrupt("return", Promise.resolve({
            code: 0,
            msg: 'success',
            config: config_data
          }));
        case 14:
          throw new Error('CDN source also failed ====> 暂不支持按应用级别兜底数据');
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getConfigByCdnByConfig(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 如果配置信息在window里已经存在，则直接返回，不触发请求
 * @param request
 * @returns
 */
var getConfigFromCache = function getConfigFromCache(request) {
  try {
    var _window, _window2;
    var key = "getConfigReq:".concat(JSON.stringify(request));
    if ((_window = window) !== null && _window !== void 0 && _window.myCache && (_window2 = window) !== null && _window2 !== void 0 && _window2.myCache[key]) {
      var _window3;
      return (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.myCache[key];
    }
    return false;
  } catch (err) {
    console.log('get data from cache error========>', err);
    throw new Error(_objectSpread(_objectSpread({}, err), {}, {
      message: 'get data from cache error========>'
    }));
  }
};
/**
 * 第一次请求成功后将返回结果挂载到window上
 * @param request
 * @param processData
 */
var setConfigCache = function setConfigCache(request, processData) {
  var key = "getConfigReq:".concat(JSON.stringify(request));
  if (!window.myCache) {
    window.myCache = {};
  }
  window.myCache[key] = processData;
};
/**
 * 请求方法
 * @param url
 * @param init
 * @param options
 * @param request
 * @returns
 */
var axiosFetch = function axiosFetch(url, init, options, request) {
  var method = init.method,
    headers = init.headers;
  var domain_name = request.domain_name,
    app_name = request.app_name,
    config_name = request.config_name;
  // 非配置获取接口触发缓存逻辑
  if (!(options !== null && options !== void 0 && options.get_schema)) {
    var cacheConfig = getConfigFromCache(request);
    if (cacheConfig && !(cacheConfig instanceof Error)) {
      return cacheConfig;
    }
  }
  return newAxios(_objectSpread({
    url: url,
    method: method.toLowerCase(),
    headers: headers,
    // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
    transformResponse: [function (data) {
      var parseData = parseDataFun(data);
      return parseData;
    }]
  }, options)).then(function (response) {
    // throw Error('111111');
    if (response.status >= 200 && response.status < 300) {
      // 这里你可以增加预处理代码，处理返回的 response 数据
      // 这只是一个简单的例子，实际的预处理可能会更复杂
      var _processData = response.data;
      if (_processData.code === 0) {
        if (!(options !== null && options !== void 0 && options.get_schema)) {
          setConfigCache(request, _processData);
        }
        return Promise.resolve(_processData);
      }
      if (_processData.code === 98001001) {
        throw new Error('服务端逻辑异常');
      }
      if (_processData.code === 98001004) {
        throw new Error('输入参数异常，服务端解析失败');
      }
      if (_processData.code === 98001022) {
        throw new Error('tos端异常，服务端回源tos拿配置时失败');
      }
    }
    var processData = processErrorData(response.data);
    return Promise.reject(processData);
  })["catch"]( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(err) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // 网络、框架层、mesh层、TLB或者别的地方有问题，导致调用失败
            // 尝试从 CDN 加载
            console.log('Primary source failed, trying CDN...');
            _context2.next = 3;
            return getConfigByCdnByConfig(domain_name, app_name, config_name);
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};
exports["default"] = axiosFetch;